export default "https://cdn-static-staging.gokick.com/assets/44c43e25e1d60214daaa18ce4b143b941a81a79a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";